<br>
<div id="homi" class="animated fadeIn col-lg-12">
    <div id="titin">
        <span> {{title}} - Version (A) 2.0.0</span>
    </div>
    <hr>
    <!--
    <div id="accordion">
        <div class="card">
            <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                    <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        ¿Como registrar un nuevo Gasto?
                    </button>
                </h5>
            </div>

-->
<!--
    <div id="tabb">

        <div id="container">
            <div ng2-carouselamos class="slides-wrapper"
                [items]="items"
                [width]="600"
                [$prev]="prev"
                [$next]="next"
                [$item]="item">
            </div>
            <ng-template #prev>
                <img style="width:50%; height: 50%" src="../../../assets/img/LEFT.png" id="left" >
            </ng-template>
            <ng-template #next>
                <img style="width:50%; height: 50%" src="../../../assets/img/RIGHT.png" id="right" >
            </ng-template>
            <ng-template #item let-item let-i="index">
                <div>
                    <img src="{{ item.name }}" id="left">
                </div>
            </ng-template>
        </div>
    -->    
        <mat-tab-group  mat-align-tabs="start">

            <mat-tab label="Datos Utiles">
                <em>
                   <p>DOCUMENTACION AFIP</p>
                </em>
                <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/obraSocialDDJJNominaDisenio.pdf"> AFIP: Diseño de Tabla NOMINAS OBRAS SOCIALES</a>
                <br>
                <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/ObraSocialDDJJNominaInstructivoDiario.pdf"> AFIP: Logica Funcional NOMINAS OBRAS SOCIALES</a>
                <br>
                <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/obraSocialTransferenciasDisenio.pdf"> AFIP: Diseño de Tabla TRANSFERENCIAS</a>
                <br>
                <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/ObraSocialTransferenciasInstructivo.pdf"> AFIP: Logica Funcional de TRANSFERENCIAS</a>
                <br>
                <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/CodigosdeConceptosdetransferenciaOS.pdf"> AFIP: CODIGOS DE CONCEPTO DE TRANSFERENCIAS</a>
                <br>
                <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/ObraSocialTransferenciasExternasInstructivoDiario.pdf"> AFIP: Logica Funcional TRANSFERENCIAS EXTERNAS (Movimientos proc. por la AFIP, que no surgen del SIPA (Sistema Integrado Previsional Argentino)</a>
                <p> financiado a través de un sistema solidario de reparto, garantizando a los afiliados y beneficiarios del régimen de capitalización vigente hasta la fecha idéntica cobertura y tratamiento que la brindada por el régimen previsional público</p>
                <p>Esta información es proporcionada a la AFIP por la Superintendencia de
                    Servicios de Salud o corresponden a movimientos ordenados por la vía judicial. </p>
            
                    <a target="_blank" href="http://www.afip.gov.ar/genericos/organismosSegSocial/archivos/obraSocialTransferenciasExternasDisenio.pdf"> AFIP: Diseño de Tabla TRANSFERENCIAS EXTERNAS (Definicion de registros)</a>
 
                </mat-tab>

            <mat-tab label="Consultar">
                <em>
                    <p>ACCESO A SERVIDORES</p>
                </em>
                <p>Configuración local</p>
                <p>Es necesario una primera configuración con las credenciales de acceso y conexión por VPN por motivos de seguridad."</p>
            </mat-tab>

            <mat-tab label="Ayuda">
                <div style="height: 360px;">
                    <p>Ante dudas o consultas enviar un mail a matiasmasciotta@urgara.org.ar</p>
                </div>

            </mat-tab>

        </mat-tab-group>

</div>